import { createContext, useState, useEffect } from "react";
import { Button } from '@mui/material';

export const PWAContext = createContext();

export function PWAProvider({ children }) {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [canInstall, setCanInstall] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setCanInstall(true);
      console.log("PWA installabile! Bottone visibile.");
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  return (
    <PWAContext.Provider value={{ deferredPrompt, canInstall, setCanInstall }}>
      {children}
    </PWAContext.Provider>
  );
}